module.exports = __webpack_public_path__ + "static/img/linepay-logo-th.7290433.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/linepay-logo-th.png
// module id = RKvm
// module chunks = 3